"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloudProvider;
(function(CloudProvider) {
  CloudProvider["AWS"] = "AWS";
  CloudProvider["AZURE"] = "AZURE";
  CloudProvider["VMWARE"] = "VMWARE";
  CloudProvider["Kubernetes"] = "kubernetes";
  CloudProvider["TerraformCloud"] = "terraformCloud";
  CloudProvider["UNKNOWN"] = "UNKNOWN";
  CloudProvider["GCP"] = "GCP";
})(CloudProvider || (CloudProvider = {}));
exports.default = CloudProvider;
//# sourceMappingURL=cloudProvider.js.map
